import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { PermissionsService } from '../../services/permission.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-monitoring-module',
  standalone: false,
  templateUrl: './monitoring-module.component.html',
})
export class MonitoringModuleComponent implements OnInit {
  activeTab: any = 'monitoring';
  comments: string[] = [];

  reviews = [
    {
      title: 'Review #1 - March 1, 2025',
      points: [
        {
          proposal: 'Proposal A',
          text: 'Technical specifications need clarification on security protocols.',
        },
        {
          proposal: 'Proposal B',
          text: 'Timeline appears aggressive for AI model training phase.',
        },
      ],
    },
  ];
  actionPoints = '';
  private subscriptions = new Subscription();
  tableColumnsObj: { field: string; header: string }[];
  unitList: any;

  dateColumns: string[] = [
    'HPSC Date',
    'Winner Declaration Date',
    'Contract Date',
    'EDC',
    'Contract Validity',
    'EDS',
    'AoN Accorded Date',
    'Bulk Production Date',
    'EDC for current Closing Date',
    'Expected Closing Date',
    'Technical Closing Date',
    'Actual Closing Date',
  ];

  // Columns that users can edit manually
  editableColumns: string[] = [
    'DIO PE',
    'Partner Incubator (PI)',
    'Nodal Officer',
  ];

  tableData: any[] = [
    {
      Ser: 1,
      Category: 'Tech',
      'Challenge Description': 'Improve system',
      'Nodal Dte': 'Dte1',
      'Nodal Officer': 'Officer1',
    },
    {
      Ser: 2,
      Category: 'Process',
      'Challenge Description': 'Streamline workflow',
      'Nodal Dte': 'Dte2',
      'Nodal Officer': 'Officer2',
    },
    {
      Ser: 3,
      Category: 'Research',
      'Challenge Description': 'New product design',
      'Nodal Dte': 'Dte3',
      'Nodal Officer': 'Officer3',
    },
  ];
  globalSearch: string = '';
  columnFilters: { [key: string]: string } = {};
  filteredData: any[] = [];
  response: any;
  columnWidths: { [key: number]: number } = {};
  selectedRowIndex: number | null = null;
  // Pagination properties
  currentPage: number = 1;
  itemsPerPage: number = 10;
  itemsPerPageOptions: number[] = [10, 25, 50, 100];
  commentText: string = '';
  selectedChallenge: any;
  proposals: any;
  challenges: any;
  selectedProposals = [];
  selectedChallenges = [];
  selectedDept = null;
  isAddColumnDialogVisible = false;
  newColumnCount: number = 0;
  newColumnLabels: string[] = [];
  displayReviewDialog = false;
  reviewPoints: string = '';
  isViewCommentDialogVisible: boolean = false;
  selectedRowComments: any;
  showAddCommentArea = false;
  equipments: any[];
  equipmentForm: FormGroup;
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  selectedequipment: any;
  systemSection: any;

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private messageService: MessageService,
    private permissionService: PermissionsService,
    private router: Router
  ) { }
  ngOnInit() {
    this.getMonitoring();
    this.equipmentForm = this.fb.group({
      edc: ['', [Validators.required]],
      // refr: ['', [Validators.required]],
      description: ['', Validators.required],
      status: [true],
      challenge: ['', Validators.required],
      date: ['', Validators.required],
      flag: ['', Validators.required],
    });
    this.selectedColumns = [...this.tableColumns];
    // this.selectedColumns = [...this.defaultColumns];
  }

  // Tab switching
  showTab(tab: any) {
    this.activeTab = tab;
    if (tab == 'reviews') {
      this.getReviewData();
      this.getUnit();
    }
  }


  // Update serial numbers
  updateSerialNumbers() {
    this.tableData.forEach((row, i) => (row['Ser'] = i + 1));
  }

  // Add a new column
  addColumn() {
    let colIndex = 1;
    let newCol = 'New Column';

    // ensure unique column name
    while (this.tableColumns.includes(newCol)) {
      colIndex++;
      newCol = `New Column ${colIndex}`;
    }

    this.tableColumns.push(newCol);
    this.tableData.forEach((row) => (row[newCol] = ''));
  }

  applyFilter() {
    this.filteredData = this.tableData.filter((row) => {
      // 🔍 Global Search
      const matchesGlobal = this.globalSearch
        ? this.tableColumns.some((col) =>
          (row[col] || '')
            .toString()
            .toLowerCase()
            .includes(this.globalSearch.toLowerCase())
        )
        : true;

      // 🔎 Column-wise filter
      const matchesColumns = this.tableColumns.every((col) => {
        if (!this.columnFilters[col]) return true;
        return (row[col] || '')
          .toString()
          .toLowerCase()
          .includes(this.columnFilters[col].toLowerCase());
      });

      return matchesGlobal && matchesColumns;
    });
    // Reset to first page when filter is applied
    this.currentPage = 1;
  }

  // Get paginated data
  get paginatedData(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.filteredData.slice(startIndex, endIndex);
  }

  // Get total pages
  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.itemsPerPage);
  }

  // Get total items count
  get totalItems(): number {
    return this.filteredData.length;
  }

  // Get start and end index for current page
  get startIndex(): number {
    return this.filteredData.length === 0 ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  get endIndex(): number {
    const end = this.currentPage * this.itemsPerPage;
    return end > this.filteredData.length ? this.filteredData.length : end;
  }

  // Pagination methods
  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  onItemsPerPageChange() {
    this.currentPage = 1; // Reset to first page when items per page changes
  }

  // Get page numbers array for pagination UI
  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  getMonitoring() {
    const sub = this.api
      .getAPI(`/idex/monitoring/module/`)
      .subscribe((res: any[]) => {
        if (Array.isArray(res)) {
          this.tableData = res.map((item, index) =>
            this.mapToTableRow(item, index)
          );
          this.filteredData = [...this.tableData];
          this.response = res;
        } else {
          this.tableData = [this.mapToTableRow(res, 0)];
          this.filteredData = [...this.tableData];
          this.response = res;
        }
      });
    this.subscriptions.add(sub);
  }

  // Map API response object to one table row
  mapToTableRow(response: any, index: number): any {
    const row: any = {};
    row.proposal_id = response.proposal_id;   // ⭐ store here
    row.id = response.id;
    this.tableColumns.forEach((col) => {
      switch (col) {
        case 'Ser':
          row[col] = index + 1;
          break;
        case 'Launch Version':
          row[col] = response.challenge.launch_version || '';
          break;
        case 'Challenge Name':
          row[col] = response.challenge.title || '';
          break;
        case 'Scheme':
          row[col] = response.scheme || '';
          break;
        case 'Challenge Description': {
          const html = response.challenge?.problem_statement || '';

          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          row[col] = tempDiv.textContent
            ?.replace(/\([^)]*\)="[^"]*"/g, '') // removes (routeConfig)="showConfirm()"
            .replace(/\s+/g, ' ')                // removes extra spaces
            .trim() || '';

          break;
        }

        case 'Nodal Dte':
          row[col] = response.challenge.nodal_dte || '';
          break;
        case 'Nodal Officer':
          row[col] = response.challenge.nodal_officer || '';

          break;
        case 'Firm Details':
          row[col] = response.vendor.company_name + ' (' + response.vendor.phone_number + ')' || '';
          break;
        case 'DIO PE':
          row[col] = response.challenge.dio_pe || '';
          break;
        case 'Partner Incubator (PI)':
          row[col] = response.challenge.pi || '';
          break;
        case 'Stage':
          row[col] = response.stage || '';
          break;
        case 'HPSC Date':
          row[col] = response.hpsc_date || '';
          break;
        case 'Winner Declaration Date':
          row[col] = response.winner_date || '';
          break;
        case 'Contract Date':
          row[col] = response.contract_date || '';
          break;
        case 'EDC':
          row[col] = response.edc || '';
          break;
        case 'Contract Validity':
          row[col] = response.contract_validity || '';
          break;
        case 'Contract Cost (Cr)':
          row[col] = response.contract_cost || '';
          break;
        // ✅ Milestones (map MS 00 → index 0, MS 01 → index 1, etc.)
        // ✅ Milestones (map MS 00 → index 0, MS 01 → index 1, etc.)

        case 'MS 00':
        case 'MS 01':
        case 'MS 02':
        case 'MS 03':
        case 'MS 04':
        case 'MS 05': {
          const milestoneIndex = parseInt(col.replace('MS ', ''), 10);
          const milestone = response.milestones?.[milestoneIndex];

          row[col] = {
            disbursed: milestone?.disbursed_amount ?? '0.00',
            actual: milestone?.actual_date
              ? new Date(milestone.actual_date).toLocaleDateString('en-GB')
              : '-',
            wbsAmount: milestone?.wbs_amount ?? '0.00',
            wbsDate: milestone?.wbs_date
              ? new Date(milestone.wbs_date).toLocaleDateString('en-GB')
              : '-',
            status: milestone?.status ?? '-'
          };

          row[col + '_hasValue'] = !!milestone;

          break;
        } case 'AoN Accorded Date':
          row[col] = response.aon_date || '';
          break;
        case 'AoN Accorded Qty':
          row[col] = response.aon_qty || '';
          break;
        case 'AoN Accorded Cost (Cr)':
          row[col] = response.aon_cost || '';
          break;
        case 'Bulk Production Date':
          row[col] = response.bulk_date || '';
          break;
        case 'Bulk Production Qty':
          row[col] = response.bulk_qty || '';
          break;
        case 'Bulk Production Cost (Cr)':
          row[col] = response.bulk_cost || '';
          break;
        case 'EDS':
          row[col] = response.bulk_eds || '';
          break;
        case 'Current activity in progress':
          row[col] = response.activities_progress || '';
          break;
        case 'EDC for current Closing Date':
          row[col] = response.edc_current_closing || '';
          break;
        case 'Expected Closing Date':
          row[col] = response.expected_closing_date || '';
          break;
        case 'Technical Closing Date':
          row[col] = response.technical_closing_date || '';
          break;
        case 'Actual Closing Date':
          row[col] = response.actual_closing_date || '';
          break;
        case 'SQR Received':
          row[col] = response.sqr_received || '';
          break;
        default:
          row[col] = '';
          break;
      }
    });
    return row;
  }

  dropRow(event: CdkDragDrop<any[]>) {
    // Calculate actual indices in filteredData considering pagination
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const actualPrevIndex = startIndex + event.previousIndex;
    const actualCurrIndex = startIndex + event.currentIndex;

    // Reorder rows in the *filtered view*
    moveItemInArray(this.filteredData, actualPrevIndex, actualCurrIndex);

    // Also reorder rows in the *main tableData* (so data stays consistent)
    const prevItem = this.filteredData[actualPrevIndex];
    const currItem = this.filteredData[actualCurrIndex];

    const prevIndexInTable = this.tableData.indexOf(prevItem);
    const currIndexInTable = this.tableData.indexOf(currItem);

    moveItemInArray(this.tableData, prevIndexInTable, currIndexInTable);
  }

  dropColumn(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.tableColumns, event.previousIndex, event.currentIndex);

    // Also reorder column data in each row
    this.tableData.forEach((row) => {
      const reordered: any = {};
      this.tableColumns.forEach((col) => {
        reordered[col] = row[col] || '';
      });
      Object.assign(row, reordered);
    });
  }
  downloadExcel() {
    // Build HTML table string
    let tableHtml = '<table border="1"><tr>';

    // Add headers
    this.tableColumns.forEach((col) => {
      tableHtml += `<th>${col}</th>`;
    });
    tableHtml += '</tr>';

    // Add rows
    this.tableData.forEach((row) => {
      tableHtml += '<tr>';
      this.tableColumns.forEach((col) => {
        tableHtml += `<td>${row[col] || ''}</td>`;
      });
      tableHtml += '</tr>';
    });

    tableHtml += '</table>';

    // Create Blob for Excel
    const blob = new Blob(['\ufeff' + tableHtml], {
      type: 'application/vnd.ms-excel;charset=utf-8;',
    });

    // Trigger download
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = 'CustomWBS.xls'; // opens in Excel
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  autoResize(event: Event, row?: any) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto'; // reset
    textarea.style.height = textarea.scrollHeight + 'px'; // expand
  }
  startRowResize(event: MouseEvent, rowIndex: number) {
    const row = (event.target as HTMLElement).closest('tr') as HTMLElement;
    const startY = event.pageY;
    const startHeight = row.offsetHeight;

    const mouseMove = (e: MouseEvent) => {
      const newHeight = startHeight + (e.pageY - startY);
      row.style.height = newHeight + 'px';
    };

    const mouseUp = () => {
      document.removeEventListener('mousemove', mouseMove);
      document.removeEventListener('mouseup', mouseUp);
    };

    document.addEventListener('mousemove', mouseMove);
    document.addEventListener('mouseup', mouseUp);
  }

  onResizeStart(event: MouseEvent, colIndex: number) {
    event.preventDefault();
    event.stopPropagation(); // prevent row drag

    const startX = event.pageX;
    const startWidth = this.columnWidths[colIndex] || 150;

    const mouseMove = (e: MouseEvent) => {
      const newWidth = startWidth + (e.pageX - startX);
      if (newWidth > 50) {
        // minimum width
        this.columnWidths[colIndex] = newWidth;
      }
    };

    const mouseUp = () => {
      document.removeEventListener('mousemove', mouseMove);
      document.removeEventListener('mouseup', mouseUp);
    };

    document.addEventListener('mousemove', mouseMove);
    document.addEventListener('mouseup', mouseUp);
  }

  onSubmit(row: any) {
    // Find the row in tableData to get the original response index
    // Since filteredData contains references to the same objects as tableData,
    // we can find the index by object reference or by comparing the 'Ser' field
    const tableDataIndex = this.tableData.findIndex(tRow =>
      tRow === row ||
      (tRow['Ser'] && row['Ser'] && tRow['Ser'] === row['Ser'])
    );

    // Use Ser - 1 as fallback, but prefer tableDataIndex if found
    const index = tableDataIndex >= 0 ? tableDataIndex : (row['Ser'] - 1);

    if (index < 0 || index >= this.response.length) {
      console.error('No matching response for row:', row);
      return;
    }

    const match = this.response[index];

    if (!match) {
      console.error('No matching proposal found for row:', row);
      return;
    }

    // 2. Prepare payload mapping
    // const payload = {
    //   proposal: match.proposal_id,
    //   stage_firm: row['Firm Details'] || '',
    //   mpoq: '',

    //   // Editable columns
    //   coordinated_agency: row['DIO PE'] || match.coordinated_agency || '',
    //   scheme: row['Partner Incubator (PI)'] || match.scheme || '',

    //   // Dates
    //   hpsc_date: this.formatDate(row['HPSC Date'] || match.hpsc_date),
    //   winner_declaration: this.formatDate(
    //     row['Winner Declaration Date'] || match.winner_date
    //   ),
    //   contract_date: this.formatDate(
    //     row['Contract Date'] || match.contract_date
    //   ),
    //   edc: this.formatDate(row['EDC']),
    //   contract_validity: this.formatDate(row['Contract Validity']),

    //   // Costs
    //   contract_cost: row['Contract Cost (Cr)'] || match.contract_cost || '',
    //   aon_progess: '',
    //   aon_date: this.formatDate(row['AoN Accorded Date']),
    //   aon_qty: row['AoN Accorded Qty'] || '',
    //   aon_cost: row['AoN Accorded Cost (Cr)'] || '',

    //   // Bulk production
    //   bulk_date: this.formatDate(row['Bulk Production Date']),
    //   bulk_qty: row['Bulk Production Qty'] || '',
    //   bulk_cost: row['Bulk Production Cost (Cr)'] || '',
    //   bulk_eds: this.formatDate(row['EDS']),

    //   // Activities
    //   activities_progress: row['Current activity in progress'] || '',
    //   edc_activities: this.formatDate(row['EDC for current Closing Date']),
    //   project_con: '',

    //   // Closing Dates
    //   expected_closing_date: this.formatDate(row['Expected Closing Date']),
    //   technical_closing_date: this.formatDate(row['Technical Closing Date']),
    //   sqr_received: this.formatDate(row['SQR Received']),
    // };
    const payload = {
      id: match.challenge.id,
      action: "update",
      // Editable columns
      dio_pe: row['DIO PE'] || match.dio_pe || '',
      pi: row['Partner Incubator (PI)'] || match.pi || '',
    }

    console.log('Payload ready:', payload);
    // return payload;
    const sub = this.api
      .postAPI(`/idex/monitoring/module/`, payload)
      .subscribe((res: any) => {
        this.getMonitoring();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Data updated successfully',
        });
      });
    this.subscriptions.add(sub);
  }


  openAddColumnDialog() {
    this.newColumnCount = 0;
    this.newColumnLabels = [];
    this.isAddColumnDialogVisible = true;
  }
  trackByIndex(index: number, _: any): number {
    return index;
  }

  closeAddColumnDialog() {
    this.isAddColumnDialogVisible = false;
  }

  generateColumnInputs() {
    // Instead of reusing strings, ensure each index is a fresh string
    this.newColumnLabels = Array.from(
      { length: this.newColumnCount },
      () => ''
    );
  }

  submitNewColumns() {
    const validLabels = this.newColumnLabels.filter(
      (label) => label.trim() !== ''
    );
    if (validLabels.length > 0) {
      this.tableColumns.push(...validLabels);
    }
    console.log('table', this.tableColumns, this.newColumnLabels);
    const sub = this.api
      .postAPI(`/idex/monitoring/extra-fiels/`, {
        labels: this.newColumnLabels,
      })
      .subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Column label added',
        });
        this.getMonitoring();
      });
    this.subscriptions.add(sub);
    this.closeAddColumnDialog();
  }
  getSelectedChallenges(proposal: any): string {
    return proposal.challenge;
  }

  openReviewDialog() {
    this.reviewPoints = '';
    this.selectedDept = null;
    this.displayReviewDialog = true;
    this.getUnit();
  }
  closeReviewDialog() {
    this.displayReviewDialog = false;
  }
  submitReviewPoints() {
    let id = this.selectedProposals.map((p) => p.id);
    // const payload = {
    //   id: this.selectedProposals.map((p) => p.id),
    //   proposals: this.selectedProposals.map((p) => p.id),
    //   department: this.selectedDept,
    // };
    const payload = {
      id: this.selectedProposals[0].id,
      proposals: this.selectedProposals[0].proposal,
      directorate: this.selectedDept,
    };

    console.log(payload);
    const sub = this.api
      .putAPI(
        `/idex/review/action-point/${this.selectedProposals[0].id}/`,
        payload
      )
      .subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Column label added',
        });
        this.getReviewData();
      });
    this.subscriptions.add(sub);

    // TODO: call API here
    this.displayReviewDialog = false;
  }

  openViewCommentPopup(r: number, row: any) {
    // r is the index in paginatedData, we need to find the actual index in filteredData
    const filteredIndex = (this.currentPage - 1) * this.itemsPerPage + r;
    const filteredRow = this.filteredData[filteredIndex];

    // Find the corresponding row in tableData to get the original response index
    // Since filteredData contains references to the same objects as tableData,
    // we can find the index by object reference or by comparing the 'Ser' field
    const tableDataIndex = this.tableData.findIndex(tRow =>
      tRow === filteredRow ||
      (tRow['Ser'] && filteredRow['Ser'] && tRow['Ser'] === filteredRow['Ser'])
    );

    // tableData index corresponds to response index (they're mapped 1:1)
    this.selectedRowIndex = tableDataIndex >= 0 ? tableDataIndex : filteredIndex;
    this.isViewCommentDialogVisible = true;
    this.getComments(this.selectedRowIndex);
  }
  getComments(r: number) {
    if (r < 0 || r >= this.response.length) {
      console.error('Invalid index for comments:', r);
      return;
    }
    const sub = this.api
      .getAPI(
        `/idex/monitoring-comments/?proposal_id=${this.response[r].proposal_id}`
      )
      .subscribe((res: any) => {
        this.selectedRowComments = res;
      });
    this.subscriptions.add(sub);
  }

  saveComment() {
    if (this.selectedRowIndex !== null) {
      this.tableData[this.selectedRowIndex].comment = this.commentText;
      let payload = {
        proposal: this.response[this.selectedRowIndex].proposal_id,
        comment: this.commentText,
        // "parent_comment":1
      };
      console.log(this.tableData[this.selectedRowIndex], payload);
      const sub = this.api
        .postAPI(`/idex/monitoring-comments/`, payload)
        .subscribe((res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Comment submitted',
          });
          this.commentText = '';
          // this.selectedRowComments.push(res[res.length-1]);
          this.getComments(this.selectedRowIndex);
          // this.getQRData(res[res.length-1])
        });
      this.subscriptions.add(sub);
    }
  }

  toggleAddCommentArea() {
    this.showAddCommentArea = !this.showAddCommentArea;
  }
  getInitials(name: string = ''): string {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  }

  getQRData(comment: any): string {
    return JSON.stringify({
      id: comment.id,
      comment: comment.comment,
      created_by: {
        name:
          comment.created_by?.first_name + ' ' + comment.created_by?.last_name,
        email: comment.created_by?.email,
      },
      code: comment.code,
    });
  }

  getReviewData() {
    const sub = this.api
      .getAPI(`/idex/review/action-point/`)
      .subscribe((res: any) => {
        this.proposals = res;
      });
    this.subscriptions.add(sub);
  }

  saveReview(proposal) {
    proposal.isEditMode = false;
    let payload = {
      proposal: proposal.proposal_id,
      review_date: proposal.reviewDate,
      edc: proposal.edc,
      action_point: proposal.actionPoints,
      flag: proposal.flag,
    };
    console.log(payload);
    const sub = this.api
      .postAPI(`/idex/review/action-point/`, payload)
      .subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Column label added',
        });
        this.getMonitoring();
        // this.fileUpload.clear();
        // this.stepCompleted.emit();
      });
    this.subscriptions.add(sub);
    this.closeAddColumnDialog();
  }
  postReviewData() { }
  trackByComment(index: number, comment: any): any {
    return comment.id; // or any unique property
  }
  printSection() {
    setTimeout(() => {
      window.print();
    }, 500); // wait for QR rendering
  }
  getUnit() {
    const sub = this.api.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
    });
    this.subscriptions.add(sub);
  }
  getProposal() {
    const sub = this.api
      .getAPI('/idex/challenge/list/')
      .subscribe((res: any) => {
        let resp = res;
        this.systemSection = resp.map((section: any) => ({
          label: section.title,
          value: section.id,
        }));
        this.challenges = res;
      });
    this.subscriptions.add(sub);
  }

  addEquipment() {
    this.equipmentForm.reset();
    this.equipmentForm.enable();
    this.showDialog = true;
    this.getUnit();
    this.getProposal();
  }

  onSubmitadd() {
    const challengeValue = this.equipmentForm.get('challenge')?.value;

    if (!challengeValue) return;

    // find section where challenge matches
    const section = this.challenges.find((s) => s.id == challengeValue);
    // console.log(section)
    let payload = {
      proposal: section.proposal,
      review_date: this.equipmentForm.get('date')?.value,
      edc: this.equipmentForm.get('edc')?.value,
      action_point: this.equipmentForm.get('description')?.value,
      flag: this.equipmentForm.get('flag')?.value,
    };
    console.log(payload);
    const sub = this.api
      .postAPI(`/idex/review/action-point/`, payload)
      .subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Data submitted successfully ',
        });
        this.showDialog = false;
        this.getReviewData();
      });
    this.subscriptions.add(sub);
  }

  updateEquipment(equipment: any): void {
    this.getProposal();
    this.equipmentForm.enable();
    this.equipmentForm.reset();
    if (equipment && equipment.id) {
      this.selectedequipment = equipment;

      const sub = this.api
        .getAPI('/idex/challenge/list/')
        .subscribe((res: any) => {
          this.systemSection = res.map((section: any) => ({
            label: section.title,
            value: section.id,
          }));

          const matchedSection = this.systemSection.find(
            (sec) => sec.label === equipment.challenge
          );
          this.equipmentForm.patchValue({
            edc: equipment.edc || '',
            date: equipment.review_date || '',
            description: equipment.action_point || '',
            challenge: matchedSection ? matchedSection.value : null, // Pre-select section by ID
            flag: equipment.flag,
          });
          this.equipmentForm.markAsDirty();
          this.subscriptions.add(sub);
          this.isUpdatedialog = true;
        });
    } else {
      console.error('Invalid equipment data provided for editing');
    }
  }

  onSubmitEq() {
    const challengeValue = this.equipmentForm.get('challenge')?.value;

    if (!challengeValue) return;

    // find section where challenge matches
    const section = this.challenges.find((s) => s.id == challengeValue);
    // console.log(section)
    let payload = {
      proposal: section.proposal,
      review_date: this.equipmentForm.get('date')?.value,
      edc: this.equipmentForm.get('edc')?.value,
      action_point: this.equipmentForm.get('description')?.value,
      flag: this.equipmentForm.get('flag')?.value,
    };
    const sub = this.api
      .putAPI(
        `/idex/review/action-point/${this.selectedequipment.id}/`,
        payload
      )
      .subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data updated successfully',
          });
          this.isUpdatedialog = false;
          this.equipmentForm.reset();
          this.getReviewData();
        } else {
          this.messageService.add({
            severity: 'failed',
            summary: 'Failed',
            detail: res.detail,
          });
        }
      });
    this.subscriptions.add(sub);
    this.isUpdatedialog = false;
  }
  getDirectorateNames(ids: number[]): string[] {
    if (!ids || !this.unitList) return [];
    return ids
      .map((id) => this.unitList.find((unit) => unit.id === id)?.name)
      .filter((name) => !!name); // remove nulls if any id not found
  }
  isRowEmpty(row: any): boolean {
    if (!row) return true;
    // Check if all values are null/undefined/empty string
    return this.tableColumns.every((col) => {
      const value = row[col];
      return (
        value === null || value === undefined || value.toString().trim() === ''
      );
    });
  }
  isResizing = false;
  resizeColumnIndex: number | null = null;
  startX = 0;
  startWidth = 0;

  startResize(event: MouseEvent, colIndex: number) {
    event.stopPropagation(); // 🚨 prevent drag reorder
    this.isResizing = true;
    this.resizeColumnIndex = colIndex;
    this.startX = event.pageX;
    this.startWidth = this.columnWidths[colIndex] || 150;

    document.addEventListener('mousemove', this.onResizeMove);
    document.addEventListener('mouseup', this.stopResize);
  }

  onResizeMove = (event: MouseEvent) => {
    if (this.isResizing && this.resizeColumnIndex !== null) {
      const diff = event.pageX - this.startX;
      this.columnWidths[this.resizeColumnIndex] = Math.max(
        80,
        this.startWidth + diff
      );
    }
  };

  stopResize = () => {
    this.isResizing = false;
    this.resizeColumnIndex = null;
    document.removeEventListener('mousemove', this.onResizeMove);
    document.removeEventListener('mouseup', this.stopResize);
  };


  // Saare available columns
  // tableColumns: string[] = [
  //   'Ser', 'Scheme', 'Launch Version', 'Challenge Name', 'Challenge Description',
  //   'Nodal Dte', 'Nodal Officer', 'DIO PE', 'Partner Incubator (PI)', 'Firm Details',
  //   'Stage', 'HPSC Date', 'Winner Declaration Date', 'Contract Date', 'EDC',
  //   'Contract Validity', 'Contract Cost (Cr)', 'MS 00', 'MS 01', 'MS 02', 'MS 03',
  //   'MS 04', 'MS 05', 'AoN Accorded Date', 'AoN Accorded Qty', 'AoN Accorded Cost (Cr)',
  //   'Bulk Production Date', 'Bulk Production Qty', 'Bulk Production Cost (Cr)',
  //   'EDS', 'Current activity in progress', 'EDC for current Closing Date',
  //   'Expected Closing Date', 'Technical Closing Date', 'Actual Closing Date', 'SQR Received'
  // ];
  tableColumns: string[] = [
    'Ser', 'Scheme', 'Launch Version', 'Challenge Name', 'Challenge Description',
    'Nodal Dte', 'Firm Details', 'DIO PE', 'Partner Incubator (PI)', 'Nodal Officer',
    'Stage', 'HPSC Date', 'Winner Declaration Date', 'Contract Date', 'EDC',
    'Contract Validity', 'Contract Cost (Cr)', 'MS 00', 'MS 01', 'MS 02', 'MS 03',
    'MS 04', 'MS 05', 'AoN Accorded Date', 'AoN Accorded Qty', 'AoN Accorded Cost (Cr)',
    'Bulk Production Date', 'Bulk Production Qty', 'Bulk Production Cost (Cr)',
    'EDS', 'Current activity in progress', 'EDC for current Closing Date',
    'Expected Closing Date', 'SQR Received'
  ];

  // Jo columns table mein dikh rahe hain
  selectedColumns: string[] = [];

  // Search text for popup list
  columnSearchText: string = '';

  // Default selection (Initial state)
  defaultColumns: string[] = ['Ser', 'Scheme', 'Challenge Name', 'Stage', 'Actual Closing Date'];



  // Checkbox toggle logic
  toggleColumn(column: string) {
    const index = this.selectedColumns.indexOf(column);
    if (index > -1) {
      this.selectedColumns.splice(index, 1); // Remove if exists
    } else {
      this.selectedColumns.push(column); // Add if not exists
    }
  }

  // Select All functionality
  selectAll() {
    this.selectedColumns = [...this.tableColumns];
  }

  // Reset functionality
  resetDefault() {
    this.selectedColumns = [...this.defaultColumns];
  }

  // Helper function to check if column is selected
  isColumnSelected(column: string): boolean {
    return this.selectedColumns.includes(column);
  }

  // Filtered list based on search input
  get filteredColumns() {
    return this.tableColumns.filter(col =>
      col.toLowerCase().includes(this.columnSearchText.toLowerCase())
    );
  }

  applyChanges() {
    console.log('Columns to display:', this.selectedColumns);

  }

  // connect review model
  proposalId: any;
  connectReview(row: any) {
    console.log("row", row);

    const url = `/idex/monitoring/module/`;

    this.api.getAPI(url).subscribe({
      next: (res: any) => {

        console.log("API Response", res);

        this.router.navigate(['/idex/review'], {
          queryParams: {
            scheme_id: row.scheme_id,
            proposal_id: row.proposal_id
          }
        });

      }
    });
  }
}
